/**
 * Popup
 */

export default function Popup() {
    const selectors = {
        'container' : '#popups',
        'toggle' : '.js-open-popup',
        'autoTimer' : 15000,
    };

    this.init = () => {
        this.handle();
        this.handlePopupAutoShow();
    };

    this.handle = () => {
        jQuery(selectors.toggle).on('click', (e) => {
            e.preventDefault();
            let $this = jQuery(e.currentTarget);
            let popup = $this.attr('data-popup');
            jQuery(selectors.container).show().find(`.${popup}`).addClass('show');
            jQuery("body").css({"overflow":"hidden"})
        })

        jQuery(selectors.container).on('click', '.close, .popup-overlay', (e) => {
            e.preventDefault();
            let $this = jQuery(e.currentTarget);
            $this.closest('.popup').removeClass('show')
            jQuery(selectors.container).hide();
            jQuery("body").css({"overflow":""})
        })

    }

    this.handlePopupAutoShow = () => {
        if (!this.hasPopupBeenShownToday() && jQuery(selectors.container).find(`.popup-consultation-auto`).length) {
            setTimeout(() => {
                if (!jQuery(selectors.container).find(".popup.show").length) {
                    jQuery(selectors.container).show().find(`.popup-consultation-auto`).addClass('show');
                    jQuery("body").css({"overflow":"hidden"})
                    localStorage.setItem('popupLastShown', new Date().toISOString());
                }
            }, selectors.autoTimer);
        }
    }

    this.hasPopupBeenShownToday = () => {
        const lastShown = localStorage.getItem('popupLastShown');
        if (!lastShown) return false;

        const lastShownDate = new Date(lastShown);
        const today = new Date();

        return (
            lastShownDate.getFullYear() === today.getFullYear() &&
            lastShownDate.getMonth() === today.getMonth() &&
            lastShownDate.getDate() === today.getDate()
        );
    }



}
